import React from "react";
import {
  formatPhoneNumber,
  numberToWords,
  formatPrice,
  invoiceCalculate,
} from "../../../utils/Common";
import QRCode from "react-qr-code";

const PdfHtmlContentPad = ({
  invoice,
  invoiceSetting,
  invoiceImeis,
  inputs,
  formattedDateTime,
  totalPricePrintPad,
  totalItemsPrintPad,
  styles,
  totalPrice,
  totalQty,
  exChangeImeis,
}) => {
  console.log(invoiceImeis)


  const totalDuePayment = invoice?.multiple_payment
    ?.filter((p) => p.invoice_id?.includes("INV-DUE"))
    ?.reduce((sum, p) => sum + Number(p.payment_amount), 0) || 0;

  return (
    <div className="hidden">
      <div
        id="pdfConentAreasPadCustomize"
        className="pdfConentAreasPadCustomize"
      >
        <div
          id="invoice-detail-page"
          className="invoice-detail-page font-nunito"
        >
          {/* invoice header */}
          {/* customer info and  + QR*/}
          <div className="flex items-center mt-[10px] justify-between">
            <div className="text-black space-y-[2px] md:space-y-[6px] font-nunito text-xs  lg:text-base">
              <p>
                {" "}
                <span className="font-semibold">Bill to,</span> <br />{" "}
                <span className="font-semibold">Customer Name </span> :{" "}
                {invoice.customer_name}{" "}
              </p>
              <p>
                <span className="font-semibold">Customer Phone</span> :{" "}
                {invoice.country_code}
                {invoice.customer_phone}
              </p>
              <p>
                <span className="font-semibold">Customer Address </span> :{" "}
                {invoice.customer_address}
              </p>
              <p>
                <span className="font-semibold"> Customer ID </span> :{" "}
                {invoice.customer_id}
              </p>
              {console.log("Courier ................... ", invoice?.stead_fast_courier)}
                  {
                    invoice?.stead_fast_courier ?
                    <>
                      <p>
                        <span className="font-semibold"> Consignment ID </span> :{" "}
                        {invoice?.stead_fast_courier?.consignment_id}
                      </p>
                      <p>
                        <span className="font-semibold"> Tracking Code </span> :{" "}
                        {invoice?.stead_fast_courier?.tracking_code}
                      </p>

                    </> : null
                  }
                  {invoice.remarks && invoice.remarks.trim() !== "" && (
                    <p>
                      <span className="font-semibold">Remarks</span>: {invoice.remarks}
                    </p>
                  )}
            </div>
            {/* web address qr code */}
            <QRCode
              className="w-[100px] object-contain p-0"
              value={
                `${process.env.REACT_APP_ROOT_URL}/invoice-view/${invoice?.invoice_id}` ||
                "No Invoice ID set to the QR code"
              }
              size={100}
            />
            {/* <div className="w-[45px] sm:w-[65px] md:w-[100px]"> */}
            <div className="flex flex-col justify-start items-start text-black space-y-[2px] md:space-y-[4px] font-nunito text-xs  lg:text-base">
              <p>
                {
                    invoice.delivery_method?.delivery_infos?.length > 0 && <>
                          <span className="font-bold">Delivery Company</span>:{" "}
                          <span>
                          {invoice.delivery_method?.delivery_infos[0]?.company_name}{" "}
                          </span>
                        </>
                }
            </p>
              {/* <QRCode className="w-full object-contain" value={BASE_URL + '/invoice/' + invoice.invoice_id} size={100} /> */}
                    {
                      invoice.user_id === 254 && invoice.custom_invoice_id !== null?
                      <p>
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.custom_invoice_id}{" "}
                      </p>
                      : <p>
                        {" "}
                        <span className="font-semibold">Invoice No</span> :{" "}
                        {invoice.invoice_id}{" "}
                      </p>
                    }
              <p>
                <span className="font-semibold">Invoice Date</span> :{" "}
                {formattedDateTime}
              </p>
            </div>
          </div>
          <div className="mx-auto md:w-full md:max-w-full overflow-x-auto mb-0 mt-3">
            <table className="table ">
              <thead id="pdfContentTHeadPad" className="pb-3">
                <tr
                  className={`leading-normal text-sm lg:text-base font-nunito tracking-wide border-b-4 border-t-4 `}
                  style={{
                    borderColor: invoiceSetting?.dummy_text
                      ? invoiceSetting?.dummy_text
                      : "#93C5FD",
                  }}
                >
                  <th
                    className="font-nunito text-left"
                    style={{ padding: "3px 5px" }}
                  >
                    #
                  </th>
                  <th
                    className="font-nunito text-start"
                    style={{ padding: "3px 5px" }}
                  >
                    Item Name
                  </th>
                  <th
                    className="font-nunito text-center"
                    style={{ padding: "3px 5px" }}
                  >
                    Warranty
                  </th>
                  <th
                    className="font-nunito text-center"
                    style={{ padding: "3px 5px" }}
                  >
                    Quantity
                  </th>
                  <th
                    className="font-nunito text-right"
                    style={{ padding: "3px 5px" }}
                  >
                    Price
                  </th>
                  <th
                    className="font-nunito text-right"
                    style={{ padding: "3px 5px" }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody className="mt-2">
                {(() => {
                  let rowCounter = 0; // Define rowCounter at the top level
                  const processedProductIds = new Set(); // To track processed product IDs and avoid duplicates
                  let subtotalPrice = 0; // To track the total price of all sales products before exchanges

                  // Sales Rows
                  const salesRows = invoice?.sales_details?.map((item) => {
                    const findImeis = invoiceImeis.filter(
                      (imei) => imei.product_id === item.product_id
                    );



                    if (findImeis.length > 0) {
                      // Skip duplicate product IDs
                      if (processedProductIds.has(item.product_id)) return null;
                      processedProductIds.add(item.product_id);
                    }
                    if (findImeis.length > 0) {
                      // Calculate total price for items with IMEIs
                      const qty = findImeis.length;
                      totalItemsPrintPad += qty;
                      subtotalPrice += findImeis.reduce(
                        (acc, prod) => acc + prod.sale_price,
                        0
                      );
                    } else {
                      // For items without IMEIs
                      const itemSubtotal = item.qty * item.price;
                      subtotalPrice += itemSubtotal;
                      totalItemsPrintPad += 1;
                      totalQty += Number(item.qty);
                    }

                    // Render rows for products
                    return findImeis.length > 0 ? (
                      findImeis.map((imei) => (
                        <tr
                          key={imei.id}
                          className="font-nunito border-[#E7EBF4] font-normal text-sm lg:text-base relative "
                        >
                          <td className="text-left" style={{ padding: "10px" }}>
                            {++rowCounter}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {/* {imei?.product_name} {imei?.optional_name} {imei?.color}{" "}
                            {imei?.storage ? `${imei.storage}GB` : ""}{" "}
                            {imei?.battery_life ? `BH-${imei.battery_life}%` : ""}{" "}
                            {imei?.regeion} */}
                            {`${imei?.product_name || ""} ${
                              imei?.optional_name || ""
                            } ${imei?.color || ""} ${
                              imei?.storage ? imei.storage + " GB" : ""
                            } - ${imei?.region || ""} ${
                              imei?.battery_life
                                ? `(${imei.battery_life}%)`
                                : ""
                            } ${imei?.box_status || ""}`}

                            <br />
                            <span className="text-[12px]">SL/IMEI : {imei?.imei}</span>
                          </td>
                          <td
                            className="text-center"
                            style={{ padding: "10px" }}
                          >
                            {invoice.defaultwarranties &&
                              invoice.defaultwarranties.map((warrantyItem) =>
                                warrantyItem.invoice_id ===
                                  invoice.invoice_id &&
                                warrantyItem.product_id === item.product_id
                                  ? warrantyItem.warranty_id == null
                                    ? `${
                                        warrantyItem.default_warranties_count ||
                                        ""
                                      } ${item.product_info.warrenty || ""}`
                                    : `${
                                        warrantyItem.warranty
                                          ?.warranties_count || ""
                                      } ${warrantyItem.warranty?.name || ""}`
                                  : null
                              )}
                          </td>
                          <td
                            className="text-center"
                            style={{ padding: "10px" }}
                          >
                            1
                          </td>
                          <td
                            className="text-right"
                            style={{ padding: "10px" }}
                          >
                            {Intl.NumberFormat('en-IN').format(imei.sale_price)}
                          </td>
                          <td
                            className="text-right font-semibold"
                            style={{ padding: "10px" }}
                          >
                            {Intl.NumberFormat('en-IN').format(imei.sale_price)}{" "}
                            {invoiceSetting?.currency_info?.code || "BDT"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr
                        key={item.id}
                        className="font-nunito border-[#E7EBF4] font-normal text-sm lg:text-base relative "
                      >
                        <td className="text-left" style={{ padding: "10px" }}>
                          {++rowCounter}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.product_info.name}
                          <br />
                          <span className="text-[10px]">
                            {item.product_info.serial}
                          </span>
                          <span className="text-[13px]">
                            {item?.product_variant?.name
                              ? item?.product_variant?.name
                              : ""}
                          </span>
                        </td>
                        <td className="text-center" style={{ padding: "10px" }}>
                          {invoice.defaultwarranties &&
                            invoice.defaultwarranties.map((warrantyItem) =>
                              warrantyItem.invoice_id === invoice.invoice_id &&
                              warrantyItem.product_id === item.product_id
                                ? warrantyItem.warranty_id == null
                                  ? `${
                                      warrantyItem.default_warranties_count ||
                                      ""
                                    } ${item.product_info.warrenty || ""}`
                                  : `${
                                      warrantyItem.warranty?.warranties_count ||
                                      ""
                                    } ${warrantyItem.warranty?.name || ""}`
                                : null
                            )}
                        </td>
                        <td className="text-center" style={{ padding: "10px" }}>
                          {item.qty}
                        </td>
                        <td className="text-right" style={{ padding: "10px" }}>
                          {item.price}
                        </td>
                        <td
                          className="text-right font-semibold"
                          style={{ padding: "10px" }}
                        >
                          {item.qty * item.price}{" "}
                          {invoiceSetting?.currency_info?.code || "BDT"}
                        </td>
                      </tr>
                    );
                  });

                  // Exchange Rows
                  let exchangeTotalPrice = 0; // Total price of exchanged products
                  const exchangeRows = exChangeImeis?.map((exchangeItem) => {
                    exchangeTotalPrice += Number(
                      exchangeItem.purchase_price || 0
                    );

                    return (
                      <tr
                        key={`exchange-${exchangeItem.id}`}
                        className="font-nunito font-normal text-sm lg:text-base relative text-red-500"
                        // style={{
                        //   borderColor: invoiceSetting?.dummy_text || "#93C5FD",
                        // }}
                      >
                        <td className="text-left" style={{ padding: "10px" }}>
                          {++rowCounter}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {/* {exchangeItem.product_name} */}
                          {`${exchangeItem?.product_name || ""} ${
                            exchangeItem?.color ? exchangeItem.color : ""
                          } ${exchangeItem?.storage ? `${exchangeItem.storage}GB` : ""} - ${exchangeItem?.regeion || ""} ${
                            exchangeItem?.battery_life
                              ? `(BH-${exchangeItem.battery_life}%)`
                              : ""
                          }`}
                          <br />
                          <span className="text-[13px]">
                            {exchangeItem.imei || "N/A"}
                          </span>
                          <span className="text-[13px]">
                            {" (Exchanged Product)"}
                          </span>
                        </td>
                        <td className="text-right" style={{ padding: "10px" }}>
                          {exchangeItem.optional_name || ""}
                        </td>
                        <td className="text-center" style={{ padding: "10px" }}>
                          {""}
                        </td>
                        <td className="text-right" style={{ padding: "10px" }}>
                          {Intl.NumberFormat('en-IN').format(exchangeItem.purchase_price) || 0}
                        </td>
                        <td
                          className="text-right font-semibold"
                          style={{ padding: "10px" }}
                        >
                          {Intl.NumberFormat('en-IN').format(exchangeItem.purchase_price) || 0}{" "}
                          {invoiceSetting?.currency_info?.code || "BDT"}
                        </td>
                      </tr>
                    );
                  });

                  totalPricePrintPad = subtotalPrice - exchangeTotalPrice; // Subtract exchange prices from subtotal

                  return [...salesRows, ...exchangeRows];
                })()}
              </tbody>
            </table>
            <div
              className={`border-b-4 mt-3 mb-3`}
              style={{
                borderColor: invoiceSetting?.dummy_text
                  ? invoiceSetting?.dummy_text
                  : "#93C5FD",
              }}
            ></div>
          </div>
          <div className="w-full flex justify-between pt-0 ml-auto ">
            {/* disclaimer */}
            {/* payment method */}
            <div style={styles.paymentMethodPrintDiv}>
              {/* Here added the code by Saif */}
              <div>
                {invoice?.multiple_payment?.length > 0 ? (
                  <>
                    {(() => {
                      const grandTotal = parseFloat(
                        (
                          Number(totalPrice) +
                          Number(invoice?.vat || 0) +
                          Number(invoice?.tax || 0) +
                          Number(invoice?.delivery_fee || 0)
                        ).toFixed(2)
                      );
                      const discount = Number(invoice?.discount || 0);
                      const paidAmount = Number(
                        invoice.paid_amount && invoice.paid_amount !== 0
                          ? invoice.paid_amount
                          : 0
                      );
                      const dueAmount = grandTotal - paidAmount;

                      // Debugging values
                      console.log("grandTotal:", grandTotal);
                      console.log("discount:", discount);
                      console.log("paidAmount:", paidAmount);
                      console.log("dueAmount:", dueAmount);

                      const remainingAmount = dueAmount - paidAmount;
                      console.log("remainingAmount:", remainingAmount);

                      const isFullyPaid = dueAmount === 0;
                      const isFullyDue = paidAmount === 0;
                      const isPartiallyPaid = paidAmount > 0;
                      console.log("isFullyPaid:", isFullyPaid);
                      console.log("isFullyDue:", isFullyDue);
                      console.log("isPartiallyPaid:", isPartiallyPaid);

                      return (
                        <>
                          {isFullyDue ? (
                            <span style={{ letterSpacing: "0.08em" }}>
                              The amount is fully due
                            </span>
                          ) : (
                            <>
                              {isFullyPaid ? (
                                <span style={{ letterSpacing: "0.08em" }}>
                                  Paid by{" "}
                                  {invoice?.multiple_payment
                                    ?.map(
                                      (payment) =>
                                        payment.payment_type.type_name
                                    )
                                    .join(", ")
                                    .replace(/, ([^,]*)$/, " and $1")}{" "}
                                </span>
                              ) : (
                                <span style={{ letterSpacing: "0.08em" }}>
                                  Paid by{" "}
                                  {invoice?.multiple_payment
                                    ?.map(
                                      (payment) =>
                                        payment.payment_type.type_name
                                    )
                                    .join(", ")
                                    .replace(/, ([^,]*)$/, " and $1")}{" "}
                                  {isPartiallyPaid ? "Partially" : ""}
                                </span>
                              )}
                            </>
                          )}
                        </>
                      );
                    })()}
                  </>
                ) : (
                  <span>No payment information available</span>
                )}
              </div>
            </div>
            {/* invoice sumary */}
            <div className="w-1/3 text-xs font-semibold pl-12 pr-2">
              <div className="space-y-[2px] mb-2">
                {/* <p className="flex justify-between">
                  <span>Total Items</span>
                  <span>{totalItemsPrintPad}</span>
                </p> */}
                <p className="flex justify-between">
                  <span>Sub Total</span>
                  <span>
                    {Intl.NumberFormat('en-IN').format(formatPrice(totalPricePrintPad))}
                    {/* {totalPrice} */}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p>
                <p className="flex justify-between">
                  <span>Discount</span>
                  <span>
                    {Intl.NumberFormat('en-IN').format(formatPrice(invoice.discount ? invoice.discount : 0))}
                    {/* {invoice.discount ? invoice.discount : 0} */}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p>
                <p className="flex justify-between">
                  <span>Delivery Fee</span>
                  <span>
                    {Intl.NumberFormat('en-IN').format(formatPrice(invoice.delivery_fee ? invoice.delivery_fee : 0))}
                    {/* {invoice.discount ? invoice.discount : 0} */}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p>
              </div>
              {/* <hr></hr> */}
              <div
                style={{ borderTop: "0.5px solid #D3D3D3", margin: "10px 0" }}
              ></div>

              <div className="my-2">
                <p className="flex justify-between">
                  <span>Grand Total</span>
                  <span>
                    {/* {formatPrice(invoiceCalculate(invoice).grandTotal)} */}
                    {
                      // Ensure values are valid numbers and calculate before toFixed
                      Intl.NumberFormat('en-IN').format(Number.parseFloat(
                        (
                          (Number(totalPricePrintPad) || 0) +
                          (Number(invoice?.vat) || 0) +
                          (Number(invoice?.tax) || 0) +
                          (Number(invoice?.delivery_fee) || 0) -
                          (Number(invoice?.discount) || 0)
                        ).toFixed(2)
                      ).toFixed(2))
                    }
                    {/* {invoice.sub_total} */}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p>

              {invoice?.multiple_payment?.length > 0 &&
                invoice.multiple_payment.map((payment, index) => (
                  <p key={index} className="flex justify-between">
                    <span className="pl-5">
                      {payment.payment_type?.type_name ||
                        payment.payment_type_category?.[0]?.payment_category_name ||
                        "Unknown"}{" "}
                      Payment{" "}
                      {payment.invoice_id?.includes("INV-DUE") && (
                        <span className="text-[10px] text-gray-500">(Due Payment)</span>
                      )}
                    </span>

                    <span>
                      {Intl.NumberFormat("en-IN").format(payment.payment_amount)}{" "}
                      {invoiceSetting?.currency_info?.code || "BDT"}
                    </span>
                  </p>
                ))}
                <p className="flex justify-between">
                  <span>Paid Amount</span>
                  <span>
                    {(() => {
                      const totalExchangePrice =
                        exChangeImeis?.reduce(
                          (acc, item) => acc + (item.purchase_price || 0),
                          0
                        ) || 0;

                      const adjustedPaidAmount =
                        (invoice.paid_amount && invoice.paid_amount !== ""
                          ? invoice.paid_amount
                          : 0);

                      return (
                        Intl.NumberFormat('en-IN').format(formatPrice(adjustedPaidAmount)) +
                        (invoiceSetting?.currency_info?.code || " BDT")
                      );
                    })()}
                  </span>
                </p>
              </div>
              {/* <hr></hr> */}
              <div
                style={{ borderTop: "0.5px solid #D3D3D3", margin: "10px 0" }}
              ></div>
              <p className="flex justify-between mt-2">
                <span>Due Amount</span>
                <span>
                  {Number.parseFloat(
                    Number(totalPricePrintPad) +
                      Number(invoice?.vat) +
                      Number(invoice?.tax) +
                      Number(invoice?.delivery_fee) -
                      Number(invoice?.discount) -
                      Number(
                        invoice.paid_amount && invoice.paid_amount !== ""
                          ? invoice.paid_amount
                          : 0
                      ) - totalDuePayment
                  ).toFixed(2) < 0
                    ? 0
                    : Intl.NumberFormat('en-IN').format(Number.parseFloat(
                        Number(totalPricePrintPad) +
                          Number(invoice?.vat) +
                          Number(invoice?.tax) +
                          Number(invoice?.delivery_fee) -
                          Number(invoice?.discount) -
                          Number(
                            invoice.paid_amount && invoice.paid_amount !== ""
                              ? invoice.paid_amount
                              : 0
                          ) - totalDuePayment
                      ).toFixed(2))}
                  {invoiceSetting?.currency_info?.code
                    ? invoiceSetting?.currency_info?.code
                    : " BDT"}
                </span>
              </p>
            </div>
          </div>
          {/* amount in words */}
          <p className="text-gray-900 mt-4 font-nunito text-xs  lg:text-base font-semibold leading-normal text-center">
            <span>In Word:</span>{" "}
            {numberToWords(formatPrice(invoiceCalculate(invoice).grandTotal))}{" "}
            taka only
          </p>
          {/* <div style={{ ...styles.div }}>
              <p className="text-white font-nunito text-xs font-bold">
                You saved {formatPrice(invoice.discount ? invoice.discount : 0)}
                {invoiceSetting?.currency_info?.code
                  ? invoiceSetting?.currency_info?.code
                  : " BDT"}{" "}
                in this purchase{" "}
              </p>
            </div> */}
          <div
            style={
              invoiceSetting?.dummy_text
                ? {
                    backgroundColor: invoiceSetting.dummy_text,
                    color: "white",
                    WebkitPrintColorAdjust: "exact",
                    padding: "10px 10px 10px 10px",
                    textAlign: "center",
                    margin: "13px 0px 10px 0px",
                  }
                : { ...styles.div }
            }
          >
            <p className="text-white font-nunito text-sm font-bold">
              You saved {Intl.NumberFormat('en-IN').format(formatPrice(invoice.discount ? invoice.discount : 0))}
              {/* You saved {invoice.discount ? invoice.discount : 0} */}
              {invoiceSetting?.currency_info?.code
                ? invoiceSetting?.currency_info?.code
                : " BDT"}{" "}
              in this purchase{" "}
            </p>
          </div>
          {/* web address qr code */}
          <QRCode
            className="w-[100px] object-contain p-0 ml-20 mt-36"
            value={
              invoice?.user_info?.web_address ||
              invoice?.user_info?.invoice_settings?.web_address ||
              "No Web Address set to the QR code"
            }
            size={100}
          />
          {/* Terms and Conditions Section */} {/* Signature Section */}
          {/* <div className="flex space-x-5 text-[10px] lg:text-sm mt-2">
            <div className=" pt-2 w-1/2 ">
              <h3 className="text-[10px] font-semibold text-gray-800 mb-2">
                Terms and Conditions
              </h3>
              <ul className="list-disc list-inside text-gray-700 text-[10px]">
                <li>All prices include taxes. Payment must be made in full at the time of purchase via accepted payment methods.</li>
                  <li>Disputes will be resolved under the laws of Bangladesh.</li>
                  <li>Defective or incorrect items will be replaced or refunded at no additional cost.</li>
                {inputs.map((item, index) => (
                  <li key={item.id || index}>{item.description}</li>
                ))}
              </ul>
            </div>

            <div className="p-4 text-xs flex flex-col items-end w-1/2 ">
              <div className="flex justify-end items-center">
                <div
                  className={`flex flex-col items-center border`}
                  style={{
                    borderColor: invoiceSetting?.dummy_text
                      ? invoiceSetting?.dummy_text
                      : "#93C5FD",
                  }}
                >
                  <hr className="w-full" />
                  <span>Authorized Signature</span>
                </div>
              </div>
            </div>
          </div> */}
          {/* footer */}
          {/* <div className="text-center font-nunito mt-2 text-xs md:text-sm lg:text-base">
            <h2 className="text-orange-500  text-xs font-semibold ">
              Thanks for purchase
            </h2>
            <p className="text-black mt-2 text-xs">
              A Product of {invoice?.user_info?.invoice_settings?.shop_name}{" "}
              </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const styles = {
  div: {
    backgroundColor: "#407BFF",
    color: "white",
    WebkitPrintColorAdjust: "exact",
    padding: "10px 10px 10px 10px",
    textAlign: "center",
    margin: "13px 0px 10px 0px",
  },
  paymentMethodDiv: {
    transform: "rotate(-45deg)",
    padding: "10px",
    textAlign: "center",
    // backgroundColor: '#407BFF',
    color: "black",
    // WebkitPrintColorAdjust: 'exact',
    margin: "30px 30px 20px 180px",
    maxWidth: "120px",
    wordWrap: "break-word",
    overflow: "hidden",
    fontSize: "13px",

    // border: '2px solid #407BFF',
    // borderRadius: '50%',
    // width: '180px',
    // height: '120px',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  paymentMethodPrintDiv: {
    transform: "rotate(-45deg)",
    padding: "10px",
    textAlign: "center",
    // backgroundColor: '#407BFF',
    color: "black",
    // WebkitPrintColorAdjust: 'exact',
    margin: "30px 30px 20px 180px",
    maxWidth: "120px",
    wordWrap: "break-word",
    overflow: "hidden",
    fontSize: "10px",

    // border: '2px solid #407BFF',
    // borderRadius: '50%',
    // width: '120px',
    // height: '120px',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
};

export default PdfHtmlContentPad;
